import styled from 'styled-components';

import { Color } from '../../enums';
import { StyledComponent } from '../../interfaces';

import { BasketSummaryItemProps } from './basketSummary.types';

export const Container: StyledComponent<'div'> = styled.div`
  padding: 20px 0;
  border-top: 1px solid ${Color.Gray300};
  border-bottom: 1px solid ${Color.Gray300};
`;

export const InnerContainer: StyledComponent<'div', BasketSummaryItemProps> = styled.div<BasketSummaryItemProps>`
  display: flex;
  justify-content: space-between;
  color: ${({ $isLastItem }: BasketSummaryItemProps): Color => $isLastItem ? Color.Black : Color.Gray500};

  & + & {
    margin-top: 8px;
  }
`;

export const BasketSummaryItem: StyledComponent<'div'> = styled.div`
  font-size: 14px;
  line-height: 18px;
`;

export const Description: StyledComponent<'div'> = styled.div`
  font-size: 14px;
  line-height: 18px;
  color: ${Color.Gray500};
  margin-top: 20px;
`;
